module.exports = __webpack_public_path__ + "static/technodat-logo-6ad32150b64a10a39c8064caec8fb55b.jpg";